import { AttendanceFilterOptionValue, FilterKey } from "@studyportals/search-filters";

import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { Degree } from "@/models/Degree";
import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";

export class Attendance extends SeoMetaDataHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const attendanceSelected = await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);

		return metaRankingSortSelected
			&& attendanceSelected
			&& (attendance === AttendanceFilterOptionValue.BLENDED
				|| attendance === AttendanceFilterOptionValue.FACE_2_FACE
			);
	}

	protected selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const attendance = this.getFilterOptionNameBy(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const year = this.getCurrentYearForSeo();

		const seoInfo = {
			title: `Best Universities for ${attendance} ${year} | SP Meta Ranking`,

			description:
				`Discover the best universities in the world with Studyportals University Meta Rankings. ` +
				`Our algorithm summarises other university ranking sites to give you the best overview.`
		};

		return Promise.resolve(seoInfo);
	}
}
